module.exports = __webpack_public_path__ + "static/media/AAgile1.95447311.png";